import { render } from "./Pagination.vue?vue&type=template&id=4ee780d0"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=4ee780d0&lang=sass"
script.render = render

export default script